import React from 'react';

export const UltraAllinclusiveIcon = ({
  width = '28',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 2 28 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width={width} height={height} rx="12" fill="white" />
        <path
          d="M6.53 18.112C5.242 18.112 4.22933 17.7433 3.492 17.006C2.75467 16.2687 2.386 15.1907 2.386 13.772V8.2H3.786V13.716C3.786 14.808 4.024 15.606 4.5 16.11C4.98533 16.614 5.66667 16.866 6.544 16.866C7.43067 16.866 8.112 16.614 8.588 16.11C9.07333 15.606 9.316 14.808 9.316 13.716V8.2H10.674V13.772C10.674 15.1907 10.3053 16.2687 9.568 17.006C8.84 17.7433 7.82733 18.112 6.53 18.112ZM12.2751 18L16.7131 8.2H18.0991L22.5511 18H21.0811L17.1191 8.984H17.6791L13.7171 18H12.2751ZM14.1651 15.55L14.5431 14.43H20.0591L20.4651 15.55H14.1651ZM24.433 18V8.2H25.833V18H24.433Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
